const _StatusColors = {
  draft: '#FAE76F',
  inSignature: '#F8B184',
  completed: '#A3E5B3',
  cancelled: '#C9545E',
  rejected: '#C9545E',
  default: '#B5C3BC',
};

const normalize = value =>
  (value || '')
    .toString()
    .trim()
    .toLowerCase();

export function getCompuMinuteStatusColor(statusId, statusName) {
  const id = Number(statusId);

  if (id === 1) return _StatusColors.draft;
  if (id === 2) return _StatusColors.inSignature;
  if (id === 3) return _StatusColors.completed;
  if (id === 4) return _StatusColors.cancelled;

  const name = normalize(statusName);

  if (name === 'borrador') return _StatusColors.draft;
  if (name === 'en firma' || name === 'en proceso de firma') {
    return _StatusColors.inSignature;
  }
  if (name === 'completada' || name === 'completado') {
    return _StatusColors.completed;
  }
  if (name === 'cancelada' || name === 'cancelado' || name === 'documento cancelado') {
    return _StatusColors.cancelled;
  }
  if (name === 'firma rechazada' || name === 'rechazada' || name === 'rechazado') {
    return _StatusColors.rejected;
  }

  return _StatusColors.default;
}
export const CompuMinuteStatusColors = _StatusColors;
